import { ChangeDetectionStrategy, Component, Input, OnInit, input } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { Nullable } from '@frontend/sports/common/core/utils/extended-types';
import { SyncUserSettingsService, UserService } from '@frontend/sports/user/feature';
import Decimal from 'decimal.js';
import { Observable, map } from 'rxjs';

import { PickId } from '../../../../core/picks/pick-id';
import { getPossibleWinningsNet } from '../../../summary/services/betslip-summary-builder.service';
import { BetslipSummaryService } from '../../../summary/services/betslip-summary.service';
import { ITaxationInfoViewModel } from '../../../taxation/components/digital/taxation-info.component';
import { IQuickBetWinningsState } from '../../quick-bet.state';
import { QuickBetUtils } from '../../services/quick-bet-utils.service';

@Component({
    selector: 'bs-quick-bet-total-returns',
    templateUrl: './quick-bet-total-returns.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./quick-bet-total-returns.component.scss'],
    standalone: false,
})
export class QuickBetTotalReturnsComponent implements OnInit {
    @Input() pickIds: PickId[];
    isPossibleWinningsUnderStakeInput = input(false);

    TAXATION_COUNTRY_ZA = 'ZA';

    taxationPopupVisible = false;

    constructor(
        public sitecore: Sitecore,
        private quickBetUtils: QuickBetUtils,
        private summaryService: BetslipSummaryService,
        public userService: UserService,
        private userSettings: SyncUserSettingsService,
    ) {}

    getWinningsState$: Observable<IQuickBetWinningsState>;

    ngOnInit(): void {
        this.getWinningsState$ = this.summaryService.getQuickBetSummary$().pipe(map((summary) => this.quickBetUtils.getWinningsState(summary)));
    }

    getPossibleWinnings(state: IQuickBetWinningsState): Nullable<Decimal> {
        return this.userSettings.isTurnoverTaxApplied && state.possibleWinnings?.greaterThan(this.userSettings.configSettings.winningsTaxThreshold)
            ? state.possibleWinningsNet
            : getPossibleWinningsNet(state.possibleWinnings, state.taxationAmount, state.winningsBoost);
    }

    getPossibleWinningsLabel(state: IQuickBetWinningsState): string {
        return state.hasTaxation ? this.sitecore.quickBetMessages.PossibleWinningsNet : this.sitecore.quickBetMessages.PossibleWinnings;
    }

    getTaxationPopupData(state: IQuickBetWinningsState): ITaxationInfoViewModel {
        return <ITaxationInfoViewModel>{
            possibleWinningsGross: state.possibleWinnings,
            possibleWinningsNet:
                this.userSettings.isTurnoverTaxApplied && state.possibleWinnings?.greaterThan(this.userSettings.configSettings.winningsTaxThreshold)
                    ? state.possibleWinningsNet
                    : state.possibleWinnings?.minus(state.taxationAmount ?? 0)?.plus(state.winningsBoost ?? 0),
            taxationAmount: state.taxationAmount,
            taxationLiabilityTitle: this.sitecore.betslip.messages.TaxLiability,
            taxationLiability: state.taxationLiability,
            winningsBoost: state.winningsBoost,
            taxationRate: state.taxationRate,
        };
    }
}
